import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

export const WhatsAppPopup = ({ phoneNumber }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user has already dismissed the popup
    const dismissed = sessionStorage.getItem('whatsapp-popup-dismissed');
    if (dismissed) {
      setIsDismissed(true);
      return;
    }

    // Show popup after 2 minutes (120000ms)
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 120000);

    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
    sessionStorage.setItem('whatsapp-popup-dismissed', 'true');
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hi! I have a question about your products.');
    window.open(`https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=${message}`, '_blank');
  };

  if (isDismissed && !isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        data-testid="whatsapp-mini-btn"
        className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 whatsapp-btn"
      >
        <MessageCircle className="h-6 w-6" />
      </button>
    );
  }

  if (!isVisible) return null;

  return (
    <div
      data-testid="whatsapp-popup"
      className="fixed bottom-6 right-6 z-50 animate-fade-in"
    >
      <div className="bg-cream rounded-2xl shadow-2xl p-6 max-w-sm border border-warm-brown/10">
        <button
          onClick={handleDismiss}
          className="absolute top-3 right-3 text-warm-brown hover:text-forest"
          data-testid="whatsapp-popup-close"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="flex items-center gap-3 mb-4">
          <div className="bg-[#25D366] p-2 rounded-full">
            <MessageCircle className="h-6 w-6 text-white" />
          </div>
          <div>
            <h4 className="font-heading font-semibold text-forest">Need Help?</h4>
            <p className="text-sm text-warm-brown">We're here to assist you!</p>
          </div>
        </div>

        <p className="text-warm-brown text-sm mb-4">
          Have questions about our products? Chat with us directly on WhatsApp!
        </p>

        <button
          onClick={handleWhatsAppClick}
          data-testid="whatsapp-chat-btn"
          className="w-full bg-[#25D366] text-white py-3 px-6 rounded-full font-medium hover:bg-[#20BD5C] transition-colors flex items-center justify-center gap-2"
        >
          <MessageCircle className="h-5 w-5" />
          Chat on WhatsApp
        </button>
      </div>
    </div>
  );
};
